<template>
  <div class="buttonDoc">
    <documentation-container :title="title">
      <template slot="content">
        <media :query="{maxWidth: 768}">
          <div>
            <h3 class="button-title">Button Size</h3>
            <div class="content-docs">
              <button class="btn-large primary">Large</button>
              <button class="btn-regular secondary">Regular</button>
              <button class="btn-small danger">Small</button>
            </div>
          </div>
        </media>
        <media :query="{minWidth: 769}">
          <div>
            <h3 class="button-title">Button Size</h3>
            <div class="content-docs">
              <button class="btn-large primary">Large</button>
              <button class="btn-regular secondary">Regular</button>
              <button class="btn-small danger">Small</button>
            </div>
            <h3 class="button-title">Button Type</h3>
            <div class="content-doc">
              <button class="btn-regular primary">Primary</button>
              <button class="btn-regular secondary">Secondary</button>
              <button class="btn-regular danger">Danger</button>
              <button class="btn-regular warning">Warning</button>
              <button class="btn-regular success">Success</button>
              <button class="btn-regular teal">Teal</button>
            </div>
            <h3 class="button-title">Button Disable</h3>
            <div class="content-doc">
              <button disabled class="btn-regular primary">Primary</button>
              <button disabled class="btn-regular secondary">Secondary</button>
              <button disabled class="btn-regular danger">Danger</button>
              <button disabled class="btn-regular warning">Warning</button>
              <button disabled class="btn-regular success">Success</button>
              <button disabled class="btn-regular teal">Teal</button>
            </div>
            <h3 class="button-title">Text Link</h3>
            <div class="content-doc">
              <button class="link">Primary <span class="ic-right"><i class="adx-ic_chevron_right"></i></span></button>
              <button disabled class="link"><span class="ic-left"><i class="adx-ic_chevron_left"></i></span> Secondary</button>
            </div>
             <h3 class="button-title">Group Button</h3>
              <adx-group-button :list="menuList" @selectedButton="selectedItem" :isDisabled="disabledList"/>
          </div>
        </media>
      </template>
    </documentation-container>
  </div>
</template>

<script>
import DocumentationContainer from '@/components/DocumentationContainer'
import GroupButton from '@/components/GroupButton'
import Media from 'vue-media';

export default {
  name: 'adx-button-doc',
  components: {
    'documentation-container': DocumentationContainer,
    'adx-group-button': GroupButton,
    'media': Media
  },
  data(){
    return{
      selected: null,
      title: 'Button',
      menuList: [
        {
          'id': 0,
          'label': 'Hour',
          'value': 'hour',
        },
        {
          'id': 1,
          'label': 'Day',
          'value': 'day',
        },
        {
          'id': 2,
          'label': 'Week',
          'value': 'week',
        },
        {
          'id': 3,
          'label': 'Month',
          'value': 'month',
        },
      ],
      disabledList: [
        'hour'
      ],
    }
  },
  methods: {
    selectedItem(value){
      this.selected = value
      if(value == 'day'){
        this.goToHome()
      }
    },
    goToHome() {
      this.$router.push({name: 'home'})
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>